import {withPayloadType} from '@lib/utils';
import {createAction} from '@reduxjs/toolkit';
import {MeetingInviteeSearchResult} from '../../data';

export const unsetNewMeeting = createAction('ui/meetings/newMeetingUnset', withPayloadType<void>());
export const setNewMeetingTitle = createAction('ui/meetings/meetingTitleSet', withPayloadType<string>());
export const setNewMeetingMessage = createAction('ui/meetings/meetingMessageSet', withPayloadType<string>());
export const setNewMeetingBuildingId = createAction('ui/meetings/meetingBuildingIdSet', withPayloadType<string>());
export const clearNewMeetingBuildingId = createAction('ui/meetings/meetingBuildingIdClear', withPayloadType<void>());
export const setIsNewMeetingAllDay = createAction('ui/meetings/meetingIsAllDaySet', withPayloadType<boolean>());
export const setIsNewMeetingOnline = createAction('ui/meetings/meetingIsOnlineSet', withPayloadType<boolean>());

export const setNewMeetingSelectedStartDateTime = createAction(
  'ui/meetings/meetingStartDateTimeSet',
  withPayloadType<string>(),
);
export const setNewMeetingSelectedEndDateTime = createAction(
  'ui/meetings/meetingEndDateTimeSet',
  withPayloadType<string>(),
);

export const setNewMeetingInvitees = createAction(
  'ui/meetings/meetingInviteesSet',
  withPayloadType<MeetingInviteeSearchResult[]>(),
);

export const setNewMeetingRooms = createAction('ui/meetings/meetingRoomsSet', withPayloadType<string[]>());

export const clearNewMeetingSelectedDateTimes = createAction(
  'ui/meetings/meetingSelectedDateTimesClear',
  withPayloadType<void>(),
);
